import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Github, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-dark-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/Final_logo.png" alt="TaskTide" className="h-8 w-auto object-contain" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
              <span className="text-lg font-bold text-gradient">TaskTide</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Tools that write themselves. 28 products across 7 categories. 
              Each one ships with a working backend, UI, and tests.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Products</h4>
            <ul className="space-y-2">
              <li><Link to="/projects" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">All Products</Link></li>
              <li><Link to="/projects/coldmail-ai" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">ColdMail AI</Link></li>
              <li><Link to="/projects/linkedin-lead-scraper" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">Lead Qualifier</Link></li>
              <li><Link to="/projects/contract-scanner" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">Contract Scanner</Link></li>
              <li><Link to="/projects/pdf-summarizer" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">PDF Summarizer</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">About</Link></li>
              <li><Link to="/about/mission" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">Mission</Link></li>
              <li><Link to="/about/technology" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">Technology</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-tasktide-teal mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Melbourne, Australia</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 text-tasktide-purple mt-0.5 flex-shrink-0" />
                <a href="mailto:info@tasktide.com.au" className="text-sm text-gray-400 hover:text-tasktide-teal transition-colors">info@tasktide.com.au</a>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://github.com/TaskTide-AI" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Github className="h-4 w-4" />
              </a>
              <a href="https://linkedin.com/company/tasktide-ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} TaskTide AI. All rights reserved.
          </p>
          <p className="text-xs text-gray-600">
            Built with FastAPI · React · Tailwind · shadcn/ui
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;